export default {
  title: 'Jobs',
  sections: {
    main: {
      fields: {
        value: {
          title:'Jobs at Swiss Engineers United',
          subTitle:'We look forward to receiving your application',
          link:'https://hmq.ch/jobs',
          text: 'Nothing seems to fit – but you have an idea? ',
          link2: 'Send us your application anyway.'
        },
      }
    }
  }
}
// https://hmq.ch/jobs
